import React, {useState} from 'react';
import {isMobileOnly as isMobile, isTablet} from 'react-device-detect';
import {Container, Row, Col, Button} from 'reactstrap';
import he from 'date-fns/locale/he';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import DatePicker from 'react-datepicker';
import {addDays} from '../../../../utilities/dateUtils';

const ChangeStartPackageDatePopup = (props) => {
  const date = props.startDate?.includes('/') ? props.startDate : props.startDate;
  const [startDate, setStartDate] = useState(new Date(date));
  const [startDateFamily, setStartDateFamily] = useState(new Date(date));

  return (
    <Container
      className={`change-start-package-date ${isMobile || (isTablet && props.isPortrait) || props.isSmallResolution ? 'isMobile' : ''}`}>
      {props.title && (
        <Row>
          <Col xs={12} className='text-center'>
            <span className='d-block bold change-start-package-date-title'>{props.title}</span>
          </Col>
        </Row>
      )}

      {props.description && (
        <Row>
          <Col xs={12} className='text-center'>
            <span className='d-block change-start-package-date-description' dangerouslySetInnerHTML={{__html: props.description}} />
          </Col>
        </Row>
      )}

      <Row>
        <Container>
          <Col className='p-0'>
            {props.isFromFamily || (props.isFamilyBonus && props.fromPackageManager) ? (
              <DatePicker
                wrapperClassName='datepicker-custom-wrapper'
                calendarClassName='datepicker-custom-calendar'
                minDate={new Date(props.startDateParent) < new Date() ? new Date() : new Date(props.startDateParent)}
                maxDate={addDays(new Date(props.startDateParent), 7)}
                locale={he}
                selected={new Date(startDateFamily) < new Date() ? new Date() : startDateFamily}
                onChange={(date) => setStartDateFamily(date)}
                inline
              />
            ) : (
              <DatePicker
                wrapperClassName='datepicker-custom-wrapper'
                calendarClassName='datepicker-custom-calendar'
                minDate={new Date()}
                locale={he}
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                inline
              />
            )}
          </Col>
        </Container>
      </Row>
      <Row>
        <Col className='change-start-package-date-button p-0'>
          <BtnSubmit
            text={props.buttonText ? props.buttonText : 'שינוי תאריך התחלת הטיסה'}
            onclick={() => {
              if (props.isFromFamily || (props.isFamilyBonus && props.fromPackageManager)) props.action(startDateFamily);
              else props.action(startDate);
            }}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default ChangeStartPackageDatePopup;
